"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageContextProvider = exports.useLanguage = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var LanguageContext = /*#__PURE__*/_react["default"].createContext();
var LanguageContextProvider = function LanguageContextProvider(_ref) {
  var children = _ref.children,
    language = _ref.language;
  var changeLanguage = function changeLanguage(lang) {
    var domains = global.__appConfig__.domainLanguages;
    var domain = Object.keys(domains).find(function (key) {
      return domains[key] === lang;
    });
    window.location.href = "http://".concat(domain);
  };
  return __jsx(LanguageContext.Provider, {
    value: {
      language: language,
      changeLanguage: changeLanguage
    }
  }, children);
};
exports.LanguageContextProvider = LanguageContextProvider;
var useLanguage = function useLanguage() {
  return (0, _react.useContext)(LanguageContext);
};
exports.useLanguage = useLanguage;